import { useSortable } from '@dnd-kit/sortable';
import { EntityLinks } from '@griply/types';
import React from 'react';
import { LifeAreaSideNavigationItem } from 'shared/components/connected/life-area-side-navigation-item';
import { TagCount } from 'shared/components/connected/navigation-tags-list';
import { FavoriteGoal } from 'shared/components/ui/favorite-goal';
import { TagSideMenuItem } from 'shared/components/ui/tag-side-menu-item';
import { Goal } from 'shared/types/goal';
import { LifeArea } from 'shared/types/life-area';
import { Favorite, FavoriteType } from 'shared/types/user-settings';

import * as Styled from './favorites-list.style';

export type FavoriteItemProps = {
  favoriteItem: Favorite;
  goals: Goal[];
  lifeAreas: LifeArea[];
  links: EntityLinks;
  currentPathname: string;
  isMoving?: boolean;
};

export const FavoriteItem: React.FC<FavoriteItemProps> = ({
  favoriteItem,
  goals,
  lifeAreas,
  links,
  currentPathname,
  isMoving,
}) => {
  const {
    setNodeRef,
    attributes,
    listeners,
    isDragging,
    transform,
    transition,
  } = useSortable({ id: favoriteItem.id });

  if (favoriteItem.type === FavoriteType.Task) {
    return null;
  }

  return (
    <Styled.DraggableContainer
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      role="presentation"
      $isDragging={isDragging}
      $transform={transform}
      $transition={transition}
    >
      {favoriteItem.type === FavoriteType.Goal && (
        <FavoriteGoal
          goal={favoriteItem.value}
          goals={goals}
          lifeAreas={lifeAreas}
          links={links}
          currentPath={currentPathname}
          isMoving={isMoving}
        />
      )}
      {favoriteItem.type === FavoriteType.LifeArea && (
        <LifeAreaSideNavigationItem
          lifeArea={favoriteItem.value}
          currentPath={currentPathname}
          isMoving={isMoving}
        />
      )}
      {favoriteItem.type === FavoriteType.Tag && (
        <TagSideMenuItem
          tag={favoriteItem.value}
          currentPath={currentPathname}
          isMoving={isMoving}
        >
          <TagCount tagId={favoriteItem.value.id} />
        </TagSideMenuItem>
      )}
    </Styled.DraggableContainer>
  );
};
